var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000000",
    strokeWidth: 20,
    ry: 192,
    rx: 192,
    id: "svg_1",
    cy: 300,
    cx: 300,
    opacity: "undefined",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,1,0,0) ",
    xmlSpace: "preserve",
    fontFamily: "sans-serif",
    fontSize: 250,
    id: "svg_4",
    y: 386.25,
    x: 265,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeDasharray: "null",
    strokeWidth: 12,
    stroke: "#0f0f00",
    fill: "#000000"
  }, "i"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    ry: 186,
    rx: 178.5,
    id: "svg_5",
    cy: 302,
    cx: 297.49998,
    fillOpacity: "null",
    strokeDasharray: "null",
    strokeWidth: 20,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.825cfe517441fa736d9c95012885ec14.svg";
export { ForwardRef as ReactComponent };